module.exports = __webpack_public_path__ + "img/eductor_parked.1604a10c.svg";